<fdr-past-performance-ui-base-card [title]="'PD.PERFORMANCE.DETAILS' | translate">
  <dsy-button
    header-right
    [iconSide]="'left'"
    [iconName]="'download'"
    [iconLibrary]="'material'"
    [iconSize]="'1.16rem'"
    variant="link"
    color="neutral"
    (click)="exportCSV()"
    [disabled]="isLoading() || rows().length === 0"
  >
    {{ 'PD.BUTTONS.DOWNLOAD' | translate }}
  </dsy-button>
  <fdr-past-performance-ui-table-state
    [class.is-placeholder-state]="isLoading() || rows().length === 0"
    [isLoading]="isLoading()"
    [hasData]="rows().length > 0"
    [totalItems]="rows().length"
  >
    <dsy-table [data]="tableDataSignal()" [conf]="tableConfSignal()">
      @for (col of columnsSignal(); track col.key) {
        <div class="mb-1 table-header" slot="header-{{ col.key }}">
          <dsy-heading level-size="lg">{{ col.header | translate }}</dsy-heading>
          <span  class="table-header__sort-icon" (click)="sortBy(col.key)" *ngIf="col.sortFunction">
            <dsy-icon library="material" name="swap_vert" density="default" elevation="auto" material-weight="400" material-grade="0"  [color]="getHeaderIconColor(col.key)"> </dsy-icon>
          </span>
        </div>
      }

      @for (row of processedRows(); track $index; let i = $index) {
        <p class="table-cell table-cell--inline" slot="cell-{{ i }}-product">
          <span class="table-cell__status-dot" [style.backgroundColor]="getChipColor(row.product)"></span>
          {{ row.product }}
        </p>
        <p class="table-cell table-cell--inline" slot="cell-{{ i }}-portfolio">
          <span class="table-cell__status-dot" [style.backgroundColor]="getChipColor(row.portfolio)"></span>
          {{ row.portfolio }}
        </p>
        <p class="table-cell table-cell--inline" slot="cell-{{ i }}-site">
          <span class="table-cell__status-dot" [style.backgroundColor]="getChipColor(row.site)"></span>
          {{ row.site || '-' }}
        </p>
        <p class="table-cell" slot="cell-{{ i }}-program">
          {{ row.program || '-' }}
        </p>
		<p class="table-cell" slot="cell-{{ i }}-organization">
		  {{ row.organization || '-' }}
		</p>

        <div class="table-cell table-cell--datetime" slot="cell-{{ i }}-eventDateUtc">
          <dsy-button variant="link" [buttonStyle]="'padding:0;'" (click)="navigateToDetail(row)">
            {{ row.eventStartDateUtc | localeDate: 'date' : '' : locale }}
          </dsy-button>

          <span class="table-cell__secondary">
            {{ row.eventStartDateUtc | localeDate: 'time' : '' : locale }} -
            {{ row.eventEndDateUtc | localeDate: 'time' : '' : locale }}
          </span>
        </div>

        <p class="table-cell" slot="cell-{{ i }}-enrolled">{{ row.enrolled | number : '1.0-1' }} kW</p>
        <p class="table-cell" slot="cell-{{ i }}-delivered">{{ row.delivered | number : '1.0-1' }} kW</p>
        <p class="table-cell" slot="cell-{{ i }}-performance">{{ row.performance | number : '1.0-0' }}%</p>
        <p class="table-cell" slot="cell-{{ i }}-dataQuality">{{ getDataQualityTranslationKey(row.dataQuality) | translate }}</p>

        <div class="table-cell" slot="cell-{{ i }}-action">
          <dsy-button
            variant="link"
            [iconSide]="'right'"
            [iconName]="'chevron_right'"
            [iconLibrary]="'material'"
            [iconSize]="'1.4rem'"
            (click)="navigateToDetail(row)"
          >
          </dsy-button>
        </div>
      }
    </dsy-table>

    <fdr-past-performance-ui-pagination [totalItems]="rows().length"></fdr-past-performance-ui-pagination>
  </fdr-past-performance-ui-table-state>
</fdr-past-performance-ui-base-card>
